import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'

export type ClientType = 'company' | 'personal'

export interface Client {
  id: number
  email: string | null
  first_name: string
  last_name: string
  country: string
  place: string
  street: string
  house_number: string
  zip_code: string
  phone_number: string | null
  email_address: string | null
  company_name: string | null
  client_type: ClientType
  created_at: string
  updated_at: string
  tax_number: string | null
  vat_number: string | null
  id_number: string | null
  document_number: string | null
}

export interface ClientReducer {
  client: Record<string, Client>
  loading: boolean
}

const initialState: ClientReducer = {
  client: {},
  loading: false
}
export const FETCH_CLIENT = createAction<string>('client_reducer/fetch_client')
export const FETCH_CLIENT_SUCCESS = createAction<Client>('client_reducer/fetch_client_success')
export const FETCH_CLIENT_FAILURE = createAction('client_reducer/fetch_client_failure')

interface UpdateClientPayload {
  data: Partial<Client>
  id: string
}
export type UpdateClientAction = PayloadAction<UpdateClientPayload>
export const UPDATE_CLIENT_DETAILS = createAction<UpdateClientPayload>('client_reducer/update_client_details')
export const UPDATE_CLIENT_DETAILS_SUCCESS = createAction<Client>('client_reducer/update_client_details_success')
export const UPDATE_CLIENT_DETAILS_FAILURE = createAction('client_reducer/update_client_details_failure')

export type CreateClientAction = PayloadAction<Omit<Client, 'id' | 'created_at' | 'updated_at'>>
export const CREATE_CLIENT =
  createAction<Omit<Client, 'id' | 'created_at' | 'updated_at'>>('client_reducer/create_client')
export const CREATE_CLIENT_SUCCESS = createAction<Client>('client_reducer/create_client_success')
export const CREATE_CLIENT_FAILURE = createAction('client_reducer/create_client_failure')

export const clientReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_CLIENT, (state) => {
      state.loading = true
    })
    .addCase(FETCH_CLIENT_SUCCESS, (state, action) => {
      state.loading = false
      state.client[action.payload.id] = action.payload
    })
    .addCase(FETCH_CLIENT_FAILURE, (state) => {
      state.loading = false
    })
    .addCase(UPDATE_CLIENT_DETAILS, (state) => {
      state.loading = true
    })
    .addCase(UPDATE_CLIENT_DETAILS_SUCCESS, (state, action) => {
      state.loading = false
      state.client[action.payload.id] = action.payload
    })
    .addCase(CREATE_CLIENT, (state) => {
      state.loading = true
    })
    .addCase(CREATE_CLIENT_SUCCESS, (state, action) => {
      state.loading = false
      state.client[action.payload.id] = action.payload
    })
    .addCase(CREATE_CLIENT_FAILURE, (state) => {
      state.loading = false
    })
})
